import api from "./configuration";
import apiUrl from "./url";
const read = async (path, params) =>
	(
		await api.request({
			method: "GET",
			url: apiUrl + path,
			params,
			useAuthInterceptor: true,
		})
	).data;
export const ScoutingVisionsAPI = {
	list: (seasonId) => read("/ScoutingVisions", {seasonId}),
	match: (id) => read("/Matches/" + id + "/visions"),
	observers: (id) => read("/Matches/" + id + "/scouting-observers"),
	put: async (id, data, token, keepalive = false) => {
		const body = JSON.stringify(data);
		const response = await fetch(apiUrl + "/Matches/" + id + "/visions/me", {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + token,
			},
			body,
			keepalive: keepalive && new TextEncoder().encode(body).length < 60000,
		});
		if (!response.ok) {
			const error = new Error("Salvataggio della visione non riuscito");
			error.response = {
				status: response.status,
				data: await response.json().catch(() => ({})),
			};
			throw error;
		}
		return response.json();
	},
};
